import FormImageUpload from '@components/forms/FormImageUpload';
import FormInputMoney from '@components/forms/FormInputMoney';
import FormInputNumber from '@components/forms/FormInputNumber';
import FormInputText from '@components/forms/FormInputText';
import { Alert } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from 'react-hook-form';
import { EventForm } from './CreateEventUtils';

export default function EditEventGeneralInfo() {
    const { watch } = useFormContext<EventForm>();
    const [name] = watch(['name']);

    return (
        <>
            <Grid size={{ sm: 12, md: 4, lg: 5 }}>
                <FormInputText name="name" label="Event Name" />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                <Alert severity="info" sx={{ marginBottom: 1 }}>
                    Registration fee is required for competitors to enter the event.
                </Alert>
                <FormInputMoney label="Registration Fee" name="fee" />
            </Grid>
            <Grid size={{ xs: 12, sm: 8, md: 5, lg: 4 }}>
                <FormInputNumber
                    label="Max Entries:"
                    name="maxEntries"
                    numberInputProps={{ min: 0, max: 1000000, placeholder: 'No Limit' }}
                    tooltip="Set a limit on the number of entries for the event. Leave blank for no limit."
                />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <FormInputText label="Event Description" name="description" />
            </Grid>
            <Grid size={{ xs: 12 }}>
                {name.length ? (
                    <FormImageUpload
                        fieldName="imageUrl"
                        description="Event Image"
                        fileDisplayName={`${name} Event Logo`}
                        presetType={'event-image'}
                        uploadTags={[name]}
                    />
                ) : null}
            </Grid>
            {/* <Grid size={{ xs: 12, md: 6 }}>
                        <FormInputCheckbox name="isPrivate" label="Private Event" />
                    </Grid> */}
        </>
    );
}
